module.exports = __webpack_public_path__ + "static/media/134.9f7972cc.png";